import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { successActions } from 'features/success';

const useSuccess = () => {
  const dispatch = useDispatch();
  const setSuccess = useCallback(success => dispatch(successActions.setSuccess(success)), [dispatch]);
  const hideSuccess = useCallback(() => dispatch(successActions.hideSuccess()), [dispatch]);

  return { setSuccess, hideSuccess };
};

export default useSuccess;